import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";
import queryString from "query-string";

import { PAGE_TYPE, setPageTitle } from "containers/App/reducer";

import {
  getIsLoading,
  getError,
  handleRegister,
  handleAzureRegister,
  updateError,
  handleLogout
} from "containers/Login/reducer";

import Registration from "components/Registration/Registration";
import { isEnabled } from "utils/featureFlags";

class RegistrationContainer extends React.PureComponent {
  constructor(props) {
    super(props);
    // this.props.handleLogout();

    let hasRegistrationToken = false;
    const queryParams = props.location.search;
    if (queryParams) {
      const paramsObj = queryString.parse(queryParams);
      if (typeof paramsObj === "object") {
        hasRegistrationToken = Boolean(paramsObj.token);
      }
    }
    const hasInviteToken = Boolean(props.match?.params?.inviteToken);

    if (isEnabled("chat-aible-registration-redirect") && !hasInviteToken && !hasRegistrationToken) {
      window.location.assign("https://enaible.aible.com/chataible");
    }
  }

  componentDidMount() {
    setPageTitle(PAGE_TYPE.REGISTRATION);
  }

  render() {
    return <Registration {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const inviteToken =
    ownProps && ownProps.match && ownProps.match.params && ownProps.match.params.inviteToken
      ? [atob(decodeURIComponent(ownProps.match.params.inviteToken))]
      : undefined;

  return {
    handleLogout: () => dispatch(handleLogout({ redirect: false })),
    handleRegister: (fullname, username, password, password_two, uiState) => {
      if (password === password_two)
        return dispatch(handleRegister(fullname, username, password, inviteToken, uiState));
      else {
        dispatch(updateError("Your passwords do not match"));
      }
    },
    handleAzureRegister: (fullname, username, company, token) =>
      dispatch(handleAzureRegister(fullname, username, company, token))
  };
};

const mapStateToProps = (state, ownProps) => {
  const queryParams = ownProps.location.search;
  let fullname, email, token, azureError, uiState;
  if (queryParams) {
    const paramsObj = queryString.parse(queryParams);
    if (typeof paramsObj === "object") {
      if (paramsObj.email) {
        email = paramsObj.email;
      }
      if (paramsObj.firstname && paramsObj.lastname) {
        fullname = paramsObj.firstname + " " + paramsObj.lastname;
      } else {
        fullname = paramsObj.firstname || paramsObj.lastname || "";
      }
      if (paramsObj.token) {
        token = paramsObj.token;
      }
      if (paramsObj.error) {
        azureError = paramsObj.error;
      }
      if (paramsObj["ui-state"]) {
        uiState = paramsObj["ui-state"];
      }
    }
  }

  return {
    fullname: fullname,
    email: email,
    token: token,
    isLoading: getIsLoading(state),
    error: getError(state) || azureError,
    uiState: uiState
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(RegistrationContainer);
